import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import PageHeading from '../../components/PageHeading/PageHeading';
import SearchInput from '../../components/SearchInput/SearchInput';
import InputForm from '../../components/InputForm/InputForm';
import instance from '../../service/axiosInstane';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import Input from '../../components/Input/Input';
import { colors } from '../../config/constants';
import EllipsisHanlder from '../../components/Ellipsis/EllipsisHanlder';

interface responseProps {
  id: string;
  code: string;
  name: string;
}

const Organization = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [state, setState] = useState<{ code: string; name: string }>({
    code: '',
    name: '',
  });
  const { code, name } = state;
  const [organizations, setOrganizations] = useState<any>([
    {
      id: '',
      code: '',
      name: '',
    },
  ]);
  const [searchedOrganization, setSearchedOrganization] = useState([
    {
      id: '',
      code: '',
      name: '',
    },
  ]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const breadcrumb = [{ path: '/organization', name: 'Organization' }];
    dispatch(update_breadcrumb(breadcrumb));
    getAllOrganization();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      addNewOrgnaization();
    }
  }, [formError]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === 'code') {
      const format = /^\S*$/;

      format.test(event.target.value) &&
        setState({
          ...state,
          [event.target.name]: event.target.value,
        });
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: ` Organization ${event.target.name} is required  `,
      });
    }
  };

  const validation = () => {
    const error: any = {};
    if (!code) {
      error.code = errorMessage.emptyOrgCode;
    } else if ((code.length > 0 && code.length < 2) || code.length > 16) {
      error.code = errorMessage.orgCodeLength;
    }
    if (!name) {
      error.name = errorMessage.emptyOrgName;
    } else if ((name.length > 0 && name.length < 2) || name.length > 64) {
      error.name = errorMessage.orgNameLength;
    }
    return error;
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const searchHandler = () => {
    const results = [];
    for (let i = 0; i < organizations.length; i++) {
      for (const key in organizations[i]) {
        if (
          organizations[i][key].toLowerCase().indexOf(searchText.toLowerCase()) != -1
        ) {
          results.push(organizations[i]);
        }
      }
    }
    if (searchText === '') {
      setSearchedOrganization(organizations);
    } else {
      setSearchedOrganization(Array.from(new Set(results)));
    }
  };
  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };
  const onSearchHanlder = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const getAllOrganization = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get('/organizations')
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: responseProps[]) => {
    setOrganizations(data);
    setSearchedOrganization(data);
    dispatch(updateIsLoading(false));
  };

  const addNewOrgnaization = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .post('/organizations', state)
      .then((response) => {
        if (response.status === 201) {
          const obj = {
            isOpen: true,
            message: response.data.message,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsFormOpen(false);
          getAllOrganization();
          setState({ ...state, name: '', code: '' });
          navigate(`/organizationSettings/${response.data.id}`);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onClear = () => {
    setSearchText('');
    setSearchedOrganization(organizations);
  };

  return (
    <>
      <div className="px-2">
        <PageHeading label="Organization Management" />
        <div className="bg-white p-2 rounded-sm shadow-lg">
          <div className="sm:w-full lg:flex items-center justify-between mb-2">
            <SearchInput
              value={searchText}
              onChange={onSearchHanlder}
              onSearch={searchHandler}
              onClear={onClear}
              handleEnterKeyPress={handleEnterKeyPress}
            />
            <Button
              label="Add"
              type="button"
              buttonType="primary"
              icon={<i className="fa-solid fa-plus"></i>}
              onClick={() => setIsFormOpen(!isFormOpen)}
            />
          </div>
          <InputForm
            title={'Add New Organization'}
            isFormOpen={isFormOpen}
            onSubmit={onSubmit}
            onCancel={() => {
              setIsFormOpen(false);
              setFormError({});
              setIsSubmit(false);
              setState({ ...state, name: '', code: '' });
            }}
          >
            <div className="lg:flex items-center justify-between">
              <Input
                type={'text'}
                placeholder={`Enter code`}
                label={'Code'}
                value={code}
                name={'code'}
                onChange={handleChange}
                error={formError?.code}
              />
              <Input
                name={'name'}
                type={'text'}
                label={'Name'}
                value={name}
                placeholder={`Enter Name`}
                onChange={handleChange}
                error={formError?.name}
              />
            </div>
          </InputForm>
          {searchedOrganization.length > 0 ? (
            <div className="w-full grid grid-cols-1 gap-1 lg:grid-cols-3 sm:grid-cols-1 sm:gap-3 mt-1 text-sm">
              {searchedOrganization?.map((item: responseProps, index: number) => (
                <div
                  className="w-full shadow-md p-4 border border-[#f2f3f5] rounded mb-5 relative"
                  key={index}
                >
                  <div className="flex items-center space-x-4 mb-1  ">
                    <div
                      className={`w-14 h-12 flex items-center justify-center rounded-sm border ${colors.primaryBorder} shadow-sm`}
                    >
                      <i
                        className={`fa-solid fa-building text-[20px] ${colors.primaryText}`}
                      ></i>
                    </div>
                    <div className="w-full ">
                      <div>
                        <EllipsisHanlder
                          word={item.code}
                          NoOfChar={15}
                          label={'Code'}
                        />
                      </div>

                      <div>
                        <EllipsisHanlder
                          word={item.name}
                          NoOfChar={15}
                          label={'Name'}
                        />
                      </div>
                      {/* <div className="flex  space-x-2">
                        <div className=" w-1/4 ">Name </div>

                        <div className="text-sky-900">
                          {item.name.length > 10
                            ? item.name.substring(0, 14) + '...'
                            : item.name}
                        </div>
                      </div> */}
                    </div>
                    <div className="text-right flex justify-end">
                      <div
                        className="px-2 py-1"
                        onClick={() => {
                          navigate(`/organizationSettings/${item.id}`);
                        }}
                      >
                        <i className="fa-solid fa-gear text-[20px] text-[#0369a1] cursor-pointer"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              className={`space-x-4 shadow-lg rounded-sm ${colors.primaryText} border p-2 m-2 w-[300px] h-[60px] flex  items-center justify-center text-[20px] mt-2`}
            >
              <div>
                <i className="fa-solid fa-face-sad-tear"></i>
              </div>
              <div className="text-sm"> Sorry! No organization found!</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Organization;
